import { exhaustMap } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { CrossWordsRound } from '@api/models/cross-words-round.entity';
import {
	CrossWordsPhaseUpdatePathVariables,
	CrossWordsRoundService,
} from '@api/services/cross-words-round.service';
import { Actions, concatLatestFrom, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';

import { GamesSelectors } from '../games.selectors';
import {
	CrossWordsPhaseActions,
	CrossWordsPhaseUpdateAction,
} from './cross-words-phase.actions';
import { CrossWordsPhaseSelectors } from './cross-words-phase.selectors';

@Injectable()
export class CrossWordsPhaseEffects {
	public update$ = createEffect(
		() => {
			return this.actions$.pipe(
				ofType(CrossWordsPhaseActions.update),
				concatLatestFrom((action) => [
					this.store.select(GamesSelectors.id),
					this.store.select(
						CrossWordsPhaseSelectors.round(action.roundId),
					),
				]),
				exhaustMap(
					([{ roundId, changes }, gameId, round]: [
						CrossWordsPhaseUpdateAction,
						string,
						CrossWordsRound,
					]) => {
						const pathVariables: CrossWordsPhaseUpdatePathVariables =
							{
								gameId,
								roundId,
							};

						const { playing } = changes;
						const { time } = round;

						return this.crossWordsRoundService.update(
							pathVariables,
							{ ...changes, time, playing },
						);
					},
				),
			);
		},
		{ dispatch: false },
	);

	constructor(
		private actions$: Actions,
		private store: Store,
		private crossWordsRoundService: CrossWordsRoundService,
	) {}
}
